import { Controller } from 'stimulus'
import { formatLocalTime } from '~/common/helpers/local_time_format'

// See local_time_component.rb for why this is formatted client-side.
export default class extends Controller {
  connect() {
    this.element.textContent = formatLocalTime(
      this.element.getAttribute('datetime'),
      undefined,
      this.element.lang
    )
  }
}
